import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { DefaultIpcChannelListeners } from './default-ipc-channel-listeners';

import { IpcChannelService } from './ipc-channel.service';

@NgModule({
	imports: [ CommonModule ],
})
export class IpcChannelModule {
	constructor(private _defaultListerners: DefaultIpcChannelListeners) {}

	static forRoot(): ModuleWithProviders {
		return {
			ngModule: IpcChannelModule,
			providers: [
				IpcChannelService,
				DefaultIpcChannelListeners,
			],
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ipc-channel/ipc-channel.module.ts